module.exports = __webpack_public_path__ + "img/wait-live.55692c27.png";